import { NgModule } from '@angular/core';
//import { AuthGuard } from '@auth0/auth0-angular';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'src/app/shared/auth.service'

import { DocumentsComponent } from 'src/app/documents/documents.component';
import { ClientsComponent } from 'src/app/clients/clients.component';
import { PersonsComponent } from 'src/app/persons/persons.component';
import { HomeComponent } from 'src/app/home/home.component';
import { UserProfileComponent } from 'src/app/user-profile/user-profile.component';
import { GlobalSettingsComponent } from 'src/app/global-settings/global-settings.component';
import { SetupComponent } from 'src/app/setup/setup.component';
import { CurrencyRatesComponent } from 'src/app/currency-rates/currency-rates.component';
import { EditDocumentComponent } from 'src/app/edit-document/edit-document.component';
import { EditDocumentSpecComponent } from 'src/app/edit-document-spec/edit-document-spec.component';
import { EditDocumentPoComponent } from 'src/app/edit-document-po/edit-document-po.component';
import { EditDocumentReceiptComponent } from 'src/app/edit-document-receipt/edit-document-receipt.component';
import { EditDocumentInventoryComponent } from 'src/app/edit-document-inventory/edit-document-inventory.component';
import { Products2Component } from 'src/app/products2/products2.component';
import { SalesLeadsComponent } from 'src/app/sales-leads/sales-leads.component';
import { EditProductComponent } from 'src/app/edit-product/edit-product.component';
import { EditClientComponent } from 'src/app/edit-client/edit-client.component';
import { EditPersonComponent } from 'src/app/edit-person/edit-person.component';
import { EditUserAccessComponent } from 'src/app/edit-user-access/edit-user-access.component';
import { AgentSetupComponent } from 'src/app/agent-setup/agent-setup.component';
import { HiddenDocumentsComponent } from 'src/app/hidden-documents/hidden-documents.component';
import { EditVariableComponent } from 'src/app/edit-variable/edit-variable.component';
import { EditSalesLeadComponent } from 'src/app/edit-sales-lead/edit-sales-lead.component';
import { ItemTurnoverSheetComponent } from 'src/app/reports/item-turnover-sheet/item-turnover-sheet.component';
import { CreatePriceListComponent } from 'src/app/reports/create-price-list/create-price-list.component';
import { PendingChangesGuard } from 'src/app/shared/pending-changes.guard';
import { ReportProductTosComponent } from 'src/app/report-product-tos/report-product-tos.component';
import { AppLayoutComponent } from './layout/app.layout.component';

const routes: Routes = [

  /*
    Role name	Composite	Description

    allow-see-profit	        False	User can see profit and all related information	
    can-create-invoice	      False	Initial user role to create invoices and proformas	
    can-edit-and-manage-deals	False	—	
    can-edit-companies	      False	Rights to edit companies and contact information	
    can-manage-currency	      False	Right to manage (create and edit currencies and rates)	
    can-manage-payments	      False	User who can manage payments information in the system. Initial level of accounting	
    can-manage-product-orders	False	User who can manage the purchase, income and shipping orders	
    can-manage-products	      False	User can create and edit the products, including the information about vendors and prices	
    can-manage-sales-leads	  False	Rights to create and edit sales leads	
    can-manage-users	        False	Rights to manage users access to system	
    can-see-companies	        False	Rights to simply see the companies and contacts	
    default-roles-portal	    True	${role_default-roles}	
    finance-manager	          False	portal manager for finance information can see all the summary	
    offline_access	          False	${role_offline-access}	
    portal-admin	            False	Can manage portal user access	
    portal-user	              False	Basic rights to login to WEBYTO portal	
    uma_authorization	        False	${role_uma_authorization}	
  */
  {
    path: '', component: AppLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
        data: { roles: ['portal-user'] }
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'home/:section',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'home/:section/:tab',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'], },
        
      },
      {
        path: 'sales-leads',
        component: SalesLeadsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user','can-manage-sales-leads'] }
      },
      {
        path: 'documents',
        component: DocumentsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        // Teams Claim deep link target (`#/agent-intake?requestId=<AgentRequests.id>`,
        // built by webyto-agent's webyto-links.ts) -- same component as 'documents',
        // which reads the requestId query param and opens the create-new-document
        // dialog on its "AI Assist" tab. See docs/PROMPT_agent-intake-confirmation-panel.md.
        path: 'agent-intake',
        component: DocumentsComponent,
        canActivate: [AuthGuard],
        // Single role, not OR'd with 'portal-user' -- AuthGuard treats route.data.roles as
        // OR logic (any listed role grants access), and 'portal-user' is the broad base
        // role every user already has, so including it here would defeat the restriction
        // CLAUDE.md documents for this panel ("requires can-use-agent realm role").
        data: { roles: ['can-use-agent'] }
      },
      {
        path: 'clients',
        component: ClientsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'products/:id',
        component: Products2Component,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'products',
        component: Products2Component,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'persons',
        component: PersonsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'product-turnover',
        component: ReportProductTosComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'setup',
        component: SetupComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-access',
        component: EditUserAccessComponent,
        canActivate: [AuthGuard],
        // webapi requires realm:portal-admin specifically on every SecurityGroups*/
        // SecurityGroupMember(s) route this page's two remaining tabs depend on
        // (SEC-SGM-ROLE-1) — a can-manage-users-only grant would let a user reach
        // this page and then get 403 on every request those tabs make, so it's
        // not a valid alternate role here.
        // Reverted to portal-admin-only 2026-09-13 (owner): the finance-manager/
        // can-manage-payments widening from earlier the same day existed only for
        // the blocked-counterparties tab, which has since moved to /agent-setup
        // along with the other agent-admin tabs — this page is back to being
        // purely Keycloak/security-group user access management.
        data: { roles: ['portal-admin'] }
      },
      {
        // Admin "hidden documents" inspector (docs/PROMPT_admin-hidden-documents-panel.md).
        // Single role, not OR'd with 'portal-user' (AuthGuard ORs route.data.roles) --
        // the API's /AdminHiddenDocuments/* is realm:portal-admin only.
        path: 'hidden-documents',
        component: HiddenDocumentsComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-admin'] }
      },
      {
        path: 'agent-setup',
        component: AgentSetupComponent,
        canActivate: [AuthGuard],
        // Same role set /edit-access carried while it hosted the blocked-
        // counterparties tab (owner, 2026-09-13) — this page's own
        // canManageBlockedCounterparties gate needs finance-manager/
        // can-manage-payments to reach the page at all, same reasoning as
        // /edit-access's comment above. The other two tabs here still require
        // the full canAccessAdminTabs bar (component-level), unaffected by
        // this route-level OR (AuthGuard.isAccessAllowed() is a real OR check).
        data: { roles: ['portal-admin', 'finance-manager', 'can-manage-payments'] }
      },
      {
        path: 'currency-rates',
        component: CurrencyRatesComponent,
        canActivate: [AuthGuard],
        data: { roles: ['finance-manager','can-manage-currency'] }
      },
      {
        // Settings-section admin table for [dbo].[Variables] (owner request,
        // 2026-09-14) -- restricted to whoever manages vendor pricing, not
        // 'portal-user' broadly, same reasoning currency-rates above uses:
        // pairing a narrow role with the base 'portal-user' role would defeat
        // the restriction (AuthGuard ORs route.data.roles).
        path: 'edit-variable',
        component: EditVariableComponent,
        canActivate: [AuthGuard],
        data: { roles: ['can-manage-products', 'portal-admin'] }
      },
      {
        path: 'edit-document/2/:id',
        component: EditDocumentReceiptComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/3/:id',
        component: EditDocumentReceiptComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/4/:id',
        component: EditDocumentReceiptComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/5/:id',
        component: EditDocumentReceiptComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/7/:id',
        component: EditDocumentSpecComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/10/:id',
        component: EditDocumentPoComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/14/:id',
        component: EditDocumentInventoryComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/16/:id',
        component: EditDocumentSpecComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      // Here we handle the edit-document routes with a more generic approach
      // For ProformaInvoice, Commertial and all types of payment
      {
        path: 'edit-document/:type/:id',
        component: EditDocumentComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-document/:type/:id/:section',
        component: EditDocumentComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-product/:id',
        component: EditProductComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-product/:id/:section',
        component: EditProductComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      // This route is for copying a product but compatible with section route
      // Deprecated
      //{
      //  path: 'edit-product/:id/:section/:copyId',
      //  component: EditProductComponent,
      //  canActivate: [AuthGuard],
      //  data: { roles: ['portal-user'] }
      //},
      {
        path: 'edit-client/:id',
        component: EditClientComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-client/:id/:section',
        component: EditClientComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-person/:id',
        component: EditPersonComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'edit-sales-lead/:id',
        component: EditSalesLeadComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'show-itemturnoverreport/:id',
        component: ItemTurnoverSheetComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
      {
        path: 'create-pricelist',
        component: CreatePriceListComponent,
        canActivate: [AuthGuard],
        data: { roles: ['portal-user'] }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
